import { useState } from 'react';

/** Adressen ohne Profilbild (404 von /api/foto) – nicht in jeder Ansicht erneut anfragen. */
const ohneBild = new Set<string>();

const initialen = (name: string | null | undefined, email: string) => {
  const teile = (name && name !== email ? name : email.split('@')[0]).split(/[\s._-]+/).filter(Boolean);
  return ((teile[0]?.[0] ?? '') + (teile.length > 1 ? teile[teile.length - 1][0] : '')).toUpperCase() || '?';
};

/** Gleichbleibende Farbe je Adresse für die Initialen. */
const farbton = (email: string) => [...email].reduce((h, c) => (h * 31 + c.charCodeAt(0)) % 360, 7);

/**
 * Profilbild aus Microsoft (über /api/foto); ohne Bild die Initialen auf farbigem Kreis.
 */
export function Avatar({ email, name, size = 24 }: { email: string; name?: string | null; size?: number }) {
  const schluessel = email.toLowerCase();
  const [fehlt, setFehlt] = useState(ohneBild.has(schluessel));
  const titel = name && name !== email ? `${name} – ${email}` : email;
  const stil = { width: size, height: size, fontSize: Math.round(size * 0.42) };
  if (fehlt)
    return <span className="avatar" style={{ ...stil, background: `hsl(${farbton(schluessel)} 45% 45%)` }} title={titel} aria-label={titel} data-testid="avatar">{initialen(name, email)}</span>;
  return (
    <img className="avatar" style={stil} src={`/api/foto?email=${encodeURIComponent(schluessel)}`} alt={titel} title={titel} data-testid="avatar"
      onError={() => { ohneBild.add(schluessel); setFehlt(true); }} />
  );
}
